import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../App/store";
import "./CurrentStats.scss";

export const CurrentStats = () => {
  const userSelector = useSelector((state: RootState) => state.user);
  const [stats, setStats] = useState<{ name: string; value: number }[]>([]);

  useEffect(() => {
    if (userSelector?.user?._id) getUser();
  }, [userSelector.user, userSelector.rank]);


  const getUser = async () => {
    // const user: any = await DataService.resources.user.get(
    //   userSelector?.user?._id as string
    // );
    setStats([
      {
        name: "Rank",
        value: userSelector.rank || 0,
      },
      {
        name: "Wins",
        value: (userSelector?.user.scores?.win as number) || 0,
      },
      {
        name: "Kills",
        value: (userSelector?.user?.scores?.kill as number) || 0,
      },
      {
        name: "Damage Done",
        value: (userSelector?.user?.scores?.damage as number) || 0,
      },
    ]);
  };

  return (
    <div className="CurrentStats">
      <div>
        <h4>Your current stats:</h4>
      </div>
      <div>
        <div className="Stats">
          {stats.map((item: any) => (
            <div key={item.name} className="Stats__item">
              <div>{item.value}</div>
              <div>{item.name} </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default CurrentStats;
